import { isDateLike, isNotEmpty, isValidDate } from '@rehaje/shared'

import { UnknownSchema } from '../../constants'
import { SchemaDefinition } from '../../models/SchemaDefinition'
import { dateHelper } from '../Schema.DateTime'

import type { SchemaDateSpecific } from '../../types'

export class SchemaDateDefinition extends SchemaDefinition {
  override defaultsMerge(
    value: any,
    schema: SchemaDateSpecific,
    initialize: boolean
  ) {
    if (initialize) {
      if (value === undefined) return schema.default
      return value
    }
    if (schema.required && value === undefined) {
      return schema.default
    }
    return value
  }

  override getIn(schema: SchemaDateSpecific, path: PropertyKey[]) {
    if (path.length === 0) return schema
    return UnknownSchema
  }

  override infer(target: any, schema: SchemaDateSpecific): SchemaDateSpecific {
    return { ...schema, type: 'Schema.Date', value: target }
  }

  override inferOnlySchema(schema: SchemaDateSpecific) {
    return schema
  }

  override inferTypeScript(schema: SchemaDateSpecific): string {
    const value = schema.value
    if (value !== undefined && this.test(value, schema))
      return JSON.stringify(value)
    return 'string'
  }

  override prune(target: any): any {
    return target
  }

  override transform(
    target: any,
    schema: SchemaDateSpecific,
    path: PropertyKey[]
  ) {
    if (target === null && schema.nullable) return target
    const isoDateString = super.transform(
      target,
      { type: 'Schema.DateTime' },
      path
    )
    if (!isoDateString) {
      return ''
    }
    if (dateHelper.DATE_ONLY_ISO_REGEX.test(isoDateString)) {
      return isoDateString
    }
    const date = new Date(isoDateString)
    return isValidDate(date)
      ? (date.toISOString().split('T')?.[0] ?? '')
      : isoDateString
  }

  override validate(target: any, schema: SchemaDateSpecific) {
    this.validateMetadata(target, schema, isDateLike, isNotEmpty)
  }
}
